// libs
import React, { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { FloatingArrow, arrow, flip, offset, shift, useDismiss, useFloating, useInteractions, useTransitionStyles, autoUpdate, } from '@floating-ui/react';
import cx from 'classnames';
// styles
import styles from './Menu.module.scss';
const defaultProps = {
    contentProps: {},
    inline: false,
    offset: 5,
};
const Menu = forwardRef((props, ref) => {
    var _a, _b, _c;
    const [anchor, setAnchor] = useState(null);
    const [open, setOpen] = useState(false);
    const arrowRef = useRef(null);
    const { refs: _refs, floatingStyles, context, update, } = useFloating({
        placement: (_a = props.placement) !== null && _a !== void 0 ? _a : 'top',
        open: open,
        onOpenChange: setOpen,
        elements: {
            reference: anchor,
        },
        transform: false,
        middleware: [
            offset(props.offset),
            flip(),
            shift(),
            arrow({
                element: arrowRef,
            }),
        ],
    });
    // Auto update dropdown content
    useEffect(() => {
        let cleanup = () => { }; // eslint-disable-line @typescript-eslint/no-empty-function
        if (_refs.floating.current &&
            _refs.reference.current &&
            props.autoUpdatePosition) {
            cleanup = autoUpdate(_refs.reference.current, _refs.floating.current, update, { ancestorScroll: true });
        }
        return () => cleanup();
    }, [
        (_b = _refs.reference) === null || _b === void 0 ? void 0 : _b.current,
        (_c = _refs.floating) === null || _c === void 0 ? void 0 : _c.current,
        props.autoUpdatePosition,
    ]);
    const dismiss = useDismiss(context);
    const { isMounted, styles: contentStyles } = useTransitionStyles(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([dismiss]);
    useImperativeHandle(ref, () => ({
        open: () => {
            const { open, onOpenChange } = context;
            !open && onOpenChange(true);
        },
        close: () => {
            const { open, onOpenChange } = context;
            open && onOpenChange(false);
        },
        refresh: () => {
            update();
        },
        get isOpen() {
            return context.open;
        },
    }), [context]);
    const contentWrapperStyles = Object.assign(Object.assign({}, contentStyles), floatingStyles);
    const anchorClass = props.inline ? styles.anchorInline : styles.anchorBlock;
    const arrowEl = props.showArrow ? (React.createElement(FloatingArrow, Object.assign({ ref: arrowRef, context: context }, props.arrowProps))) : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", Object.assign({ ref: setAnchor }, getReferenceProps(), { className: anchorClass }), props.children),
        isMounted ? (React.createElement(React.Fragment, null,
            React.createElement("div", Object.assign({ ref: _refs.setFloating, className: cx(styles.dropdown, props.className), style: contentWrapperStyles }, getFloatingProps()),
                React.createElement(props.Content, Object.assign({}, props.contentProps)),
                arrowEl))) : null));
});
Menu.defaultProps = defaultProps;
export default memo(Menu);
